import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-time", "data-timeS"]
const _hoisted_2 = { class: "price-ticks-history-item__cell price-ticks-history-item__cell--side" }
const _hoisted_3 = { class: "price-ticks-history-item__cell price-ticks-history-item__cell--amount" }
const _hoisted_4 = { class: "price-ticks-history-item__cell price-ticks-history-item__cell--price" }
const _hoisted_5 = { class: "price-ticks-history-item__cell price-ticks-history-item__cell--time" }

import { computed, type PropType } from 'vue';

import LocalTime from '@exchange/libs/components/history/LocalTime.vue';
import type { PricetickModel } from '@exchange/libs/price-ticks/service/src';

const timeFormat = 'HH:mm:ss';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceTicksHistoryItem',
  props: {
  /** Price tick to show */
  priceTick: { type: Object as PropType<PricetickModel>, required: true },
  /** Defines if arrow should be shown */
  showArrow: { type: Boolean, required: true },
  /** Market amount precision */
  amountPrecision: { type: Number, required: true },
  /** Market market precision */
  marketPrecision: { type: Number, required: true },
},
  setup(__props) {

const props = __props;

const amount = computed(() => props.priceTick.amount.toFixed(props.amountPrecision));
const price = computed(() => props.priceTick.price.toFixed(props.marketPrecision));
const isoTime = props.priceTick.time?.toISOString();

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["price-ticks-history-item", [__props.priceTick.isBuy ? 'price-ticks-history-item--buy' : 'price-ticks-history-item--sell']]),
    "data-time": _unref(isoTime),
    "data-timeS": __props.priceTick.timeString
  }, [
    _createElementVNode("td", _hoisted_2, [
      (__props.showArrow)
        ? (_openBlock(), _createBlock(_component_ot_icon, {
            key: 0,
            class: "price-ticks-history-item__icon",
            name: __props.priceTick.isBuy ? 'arrow-up' : 'arrow-down'
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(amount.value), 1)
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("span", null, _toDisplayString(price.value), 1)
    ]),
    _createElementVNode("td", _hoisted_5, [
      _createVNode(LocalTime, {
        time: __props.priceTick.time,
        format: timeFormat
      }, null, 8, ["time"])
    ])
  ], 10, _hoisted_1))
}
}

})